
eval("define(\'text!orouser/templates/datagrid/action-permissions-field-view.html\',[],function () { return \'<div class=\"field-name\"><%=label %></div>\\n<ul data-name=\"field-permissions-items\" class=\"action-permissions\"></ul>\\n\';});\n\n//# sourceURL=/text!orouser/templates/datagrid/action-permissions-field-view.html");

